import { VisitorContextType } from "src/providers/VisitorContext/types";

const isValidUrl = (url?: string | null) => {
  if (!url) {
    return false;
  }

  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}

const persistAffiliationQueryParams = (visitorContext: VisitorContextType, destination?: string) => {
  if (!destination || !isValidUrl(destination)) {
    return destination;
  }

  if (!destination.includes("landbot")) {
    return destination;
  }

  const url = new URL(destination);

  const { affiliateLandingHref } = visitorContext;

  const landingUrl = isValidUrl(affiliateLandingHref) ? new URL(affiliateLandingHref!) : undefined;
  const currentSearchParams = landingUrl ? landingUrl.searchParams : new URLSearchParams();

  for (let [key] of currentSearchParams.entries()) {
    if (key !== "va") currentSearchParams.delete(key);
  }

  const searchParams = combineSearchParams(currentSearchParams.toString(), url.searchParams.toString());

  return `${url.origin}${url.pathname}${searchParams}`;
}

/**
 * Combine two search param strings into one
 * In case of conflict on any key, the value of the second search param string will be used
 */
const combineSearchParams = (search1?: string | null, search2?: string | null) => {
  const params1 = search1 ? new URLSearchParams(search1) : new URLSearchParams();
  const params2 = search2 ? new URLSearchParams(search2) : new URLSearchParams();
  for (let [key, val] of params2.entries()) {
    params1.set(key, val);
  }

  const hasEntries = [...new Set(params1.keys())].length > 0;
  return hasEntries ? `?${params1.toString()}` : '';
};

/**
 * Returns the appropriate internal link by combining the search params
 * if and only if this is for a page script
 */
const getInternalLink = (linkURL: string, link: Gatsby.LinkFragment, sourceSearch: string, destinationSearch?: string | null) => {
  const isPageScript = link.type === 'page_script';
  const additionalSearch = isPageScript ? sourceSearch : '';
  const searchParams = combineSearchParams(additionalSearch, destinationSearch);

  return `${linkURL}${searchParams}`;
};

export { persistAffiliationQueryParams, combineSearchParams, getInternalLink, isValidUrl };
